import { type FC, createContext, useContext, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation,useNavigate } from 'react-router-dom'

import ImgInCircle from 'components/UI/ImgInCircle/ImgInCircle'
import { Icons } from 'helpers/icons'
import { LoginForm } from 'pages/auth/view/LoginForm'
import { Register } from 'pages/auth/view/Register/Register'
import { type IModalContext } from 'types/interfaces/IModalContext'

import styles from './_modal.module.scss'

const defaultValues = {
    window: [],
    title: ''
}
type AddModal = (
    title: string,
    window: any,
    withoutTitle?: boolean,
    withoutCloseIcon?: boolean,
    customClass?: string,
    key?: string
) => void
/* interface IModalContextValues {
    addModal: AddModal
    clearModal: () => void
    addScroll: () => void
    removeScroll: () => void
    isOpen: boolean
    key: string
} */
export const AuthModalContext = createContext<any>(defaultValues)

export const AuthModalProvider: FC<{ children?: any }> = ({ children }) => {
    const [state, setState] = useState<IModalContext>({
        title: '',
        withoutTitle: false,
        withoutCloseIcon: false,
        withScroll: true,
        customClass: '',
        window: null,
        key: ''
    })
    const navigate = useNavigate()
    const addModal: AddModal = (
        title,
        window,
        withoutTitle,
        withoutCloseIcon,
        customClass,
        key = ''
    ) => {
        setState({
            title,
            window,
            withoutTitle,
            withoutCloseIcon,
            customClass,
            key
        })
    }
    const location = useLocation()
    const isForm = () => {
        return (
            location.pathname === '/auth/signup/fan' ||
            location.pathname === '/auth/signup/model' ||
            location.pathname === '/auth/login/fan' ||
            location.pathname === '/auth/login/model' ||
            location.pathname === '/auth/recover/model'
        )
    }
    const { t } = useTranslation()

     const clearModal = () => {
        if (
            window.location.pathname.includes('/auth/login') ||
            window.location.pathname.includes('/auth/signup')
        ) {
            navigate(-1)
            return
        }
        setState({ title: '', window: null })
    }

    const addScroll = () => {
        setState({ ...state, withScroll: true })
    }
    const removeScroll = () => {
        setState({ ...state, withScroll: false })
    }

    useEffect(() => {
        if (state.window) {
            if (!state.withScroll) {
                document.body.classList.add(styles.modal__scrollblock)
            }
            if (state.withScroll) {
                if (
                    document.body.classList.contains(styles.modal__scrollblock)
                ) {
                    document.body.classList.remove(styles.modal__scrollblock)
                }
            }
        } else {
            document.body.classList.remove(styles.modal__scrollblock)
        }
    }, [state])

    const isLandingAuthModal = [
        'login',
        'signup',
        'forgetPassword',
        'resetPassword'
    ].includes(state.title)

    return (
        <AuthModalContext.Provider
            value={{
                addModal,
                clearModal,
                addScroll,
                removeScroll,
                isOpen: state.window,
                key: state.key
            }}
        >
            <div
                className={` 
                ${styles.modal} 
                ${
                    state.window
                        ? styles['modal--active']
                        : styles['modal--inactive']
                } 
                ${state.withScroll ? styles['modal--withScroll'] : ''} 
                ${state.customClass ? state.customClass : ''}
            `}
                onClick={e => e.target === e.currentTarget && clearModal()}
            >
                {state.window && (
                    <div
                        className={`${styles.modal__overlay} ${
                            isLandingAuthModal
                                ? styles.modal__overlay__landingAuth
                                : ''
                        }`}
                    >
                        <div className={styles.modal__overlay__ring}>
                            <ImgInCircle
                                type='login'
                                customClass={`ll__logos__circle ${
                                    isForm() ? 'll__logos__circle--form' : ''
                                }`}
                            >
                    <img
    src='/logo.png'
    alt={t('logo')}
    style={{ width: '60px', height: '60px' }}
/>
                            </ImgInCircle>
                        </div>
                        <div
                            className={`${styles.modal__card} ${
                                state.withoutTitle
                                    ? styles.modal__card__withoutTitle
                                    : ''
                            }`}
                        >
                            {!state.withoutTitle ? (
                                <h4 className={styles.modal__title}>
                                    {state.withoutTitle ? '' : state.title}{' '}
                                    {!state.withoutCloseIcon && (
                                        <img
                                            onClick={clearModal}
                                            src={Icons.close}
                                            alt={'closeModal'}
                                        />
                                    )}
                                </h4>
                            ) : (
                                !state.withoutCloseIcon && (
                                    <img
                                        className={
                                            styles.modal__card__withoutTitle__close
                                        }
                                        onClick={clearModal}
                                        src={Icons.close}
                                        alt={'closeModal'}
                                    />
                                )
                            )}
                            {state.window}
                            {state.title === 'signup' && (
                                <>
                                    <div className='login-signup'>
{/*                                         <p>
                                            By tapping Continue, you agree to
                                            out{' '}
                                            <a href='/terms' target='_blank'>
                                                Terms of Service
                                            </a>{' '}
                                            (including) arbitration clause in
                                            Section 9) and {' '}
                                            <a href='/privacypolicy' target='_blank'>
                                                Privacy Policy
                                            </a>
                                        </p> */}
                                        <p className='text-footer'>
                                            Already have an account?
                                            <span
                                                onClick={() =>
                                                    addModal(
                                                        'login',
                                                        <LoginForm />,
                                                        true,
                                                        false
                                                    )
                                                }
                                            >
                                                Log in
                                            </span>
                                        </p>
                                    </div>
                                </>
                            )}
                            {state.title === 'login' && (
                                <>
                                    <div className='login-signup'>
                                        <p>
                                            By logging in, you agree to
                                            our{' '}
                                            <a href='/terms' className='terms-link' target='_blank'>
                                                Terms of Service
                                            </a>{' '}
                                            and {' '}
                                            <a href='/privacypolicy' className='terms-link' target='_blank'>
                                                Privacy Policy
                                            </a>
                                        </p>

                                        <p className='text-footer'>
                                            {`Don't have an account?`}
                                            <span
                                                onClick={() => {
                                                    addModal(
                                                        'signup',
                                                        <Register />,
                                                        true,
                                                        false
                                                    )
                                                }}
                                            >
                                                Sign Up
                                            </span>
                                        </p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
            {children}
        </AuthModalContext.Provider>
    )
}

export const useAuthModalContext = () => useContext(AuthModalContext)
